import React, { useEffect, useRef } from 'react';
import EmailEditor from 'react-email-editor';

export const EmailEditorImpl = ({
  formik,
  fieldName = 'email_message',
  design
}) => {
  const emailEditorRef = useRef(null);

  const editorDesign =
    design !== undefined
      ? design
      : formik.values.email_editor_design_object;

  const loadDesign = () => {
    if (emailEditorRef.current?.editor && editorDesign) {
      try {
        emailEditorRef.current.editor.loadDesign(editorDesign);
      } catch (error) {
        console.warn(
          'Email message is not in JSON format. Loading default design.'
        );
      }
    }
  };

  const handleExport = () => {
    if (emailEditorRef.current?.editor) {
      emailEditorRef.current.editor.exportHtml(({ design, html }) => {
        formik.setFieldValue(fieldName, html);
        formik.setFieldValue('email_editor_design_object', design);
      });
    }
  };

  const handleEditorReady = () => {
    console.log('Email Editor is ready');

    loadDesign();

    emailEditorRef.current.editor.addEventListener(
      'design:updated',
      handleExport
    );
  };

  useEffect(() => {
    if (design !== undefined && emailEditorRef.current?.editor) {
      loadDesign();
    }
  }, [design]);

  useEffect(
    () => () => {
      if (emailEditorRef.current?.editor) {
        emailEditorRef.current.editor.removeEventListener(
          'design:updated',
          handleExport
        );
      }
    },
    []
  );

  return (
    <EmailEditor
      ref={emailEditorRef}
      onReady={handleEditorReady}
    />
  );
};
